import { Component, Input, OnInit } from '@angular/core';
import { PaymentRequestDetail } from 'app/shared/models/payment-request-detail.model';
import { PaymentRequestService } from 'app/shared/services/payment-request.service';

@Component({
  selector: 'app-payment-request-details',
  templateUrl: './payment-request-details.component.html',
  styleUrls: ['./payment-request-details.component.scss']
})
export class PaymentRequestDetailsComponent implements OnInit {

  @Input() currentObjectId: number;

  currentObject: PaymentRequestDetail;

  constructor(protected paymentRequestService: PaymentRequestService) {
  }

  ngOnInit(): void {
    this.currentObject = new PaymentRequestDetail();
    this.paymentRequestService.getObject<PaymentRequestDetail>('/payment-request/' + this.currentObjectId, null, (paymentRequestDetail) => {
      this.currentObject = paymentRequestDetail;
    });
  }
}
